import { Directive, HostListener, Output, EventEmitter, ElementRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[thehubzFileDragNDrop]',
})
export class FileDragNDropDirective {
  @Output() fileDropped = new EventEmitter<any>();

  constructor(private elRef: ElementRef) {}

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.elRef.nativeElement.style.backgroundColor = '#94a3b8';
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.elRef.nativeElement.style.backgroundColor = '#f8fafc';
  }

  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.elRef.nativeElement.style.backgroundColor = '#f8fafc';
    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropped.emit({files, fileDropped: true});
    }
  }
}
